import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Sidebar from './Sidebar'
import AcademyBackground from '@/components/layout/AcademyBackground'
import StorageHealthBanner from '@/components/StorageHealthBanner'
import '@/styles/academyTheme.css'
/* Soft Orbit V2 shell tokens. Protected pretest content remains unscoped. */
import '@/styles/techLabTheme.css'

function getPageKind(pathname: string, search: string) {
  if (pathname.startsWith('/learning-path') || pathname === '/language-forest') return 'growth'
  if (pathname === '/progress' && !search.includes('mode=ai-teacher')) return 'report'
  if (pathname.startsWith('/me')) return 'report'
  if (pathname === '/friends' || pathname === '/courses') return 'index'
  if (pathname === '/pretest') return 'pretest'
  return 'workbench'
}

export default function Layout() {
  const location = useLocation()
  const { pathname } = location
  const isFocusedPretest = pathname === '/pretest'
  const isFocusedPractice = pathname === '/practice'
    && new URLSearchParams(location.search).get('start') === '1'
  const isMyWorkspace = pathname.startsWith('/me')

  const hideSidebar = isFocusedPractice || isFocusedPretest

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [location.key])

  return (
    <AcademyBackground particles={!isFocusedPretest} visualScope={isFocusedPretest ? 'pretest' : 'app'}>
      {!hideSidebar && <Sidebar />}
      <StorageHealthBanner />
      <main
        className={`app-main app-shell-main light-shell soft-orbit-shell${hideSidebar ? ' app-main-focused' : isMyWorkspace ? ' app-main-profile' : ''}`}
        data-page-kind={getPageKind(pathname, location.search)}
      >
        <Outlet />
      </main>
    </AcademyBackground>
  )
}
